import { render } from "./FirstView.vue?vue&type=template&id=75dab151"
const script = {}

import "./FirstView.vue?vue&type=style&index=0&id=75dab151&lang=css"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__